/**
 * La pagina «Scarica l'app» (/app): dove porta, e da dove arriva la gente.
 *
 * PERCHE' ESISTE (lista di Umberto, 05/10/2026, punto 1): le firme email, il
 * banco e la newsletter di Datacom devono mandare a UN indirizzo solo, che sul
 * telefono capisce da sé quale negozio aprire. Un solo QR stampato vale per
 * tutti: chi ha un Android va su Google Play, chi ha un iPhone su App Store,
 * chi legge la mail dal computer trova il QR da inquadrare col telefono.
 *
 * Sull'iPhone l'account NON si crea nell'app (Apple 3.1.1, quarto rifiuto,
 * 05/10): per questo la pagina mette per primo «Crea l'account» sul sito.
 */

export const INDIRIZZO_APP = "https://ai.datacomtecnologie.it/app";

export const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=it.datacomtecnologie.ai";

/**
 * App Store: acceso il 06/10/2026. Apple ha approvato la build 128 e la
 * versione 1.0 è sull'App Store italiano dalle 20:40 (letto dall'elenco
 * pubblico di Apple, itunes.apple.com/lookup?id=6809735960). Con null il
 * pulsante dell'iPhone dice «in arrivo» e propone il browser: serve solo se un
 * giorno l'app dovesse sparire dal negozio.
 */
export const APP_STORE: string | null = "https://apps.apple.com/it/app/datacom-ai/id6809735960";

export type Dispositivo = "iphone" | "android" | "computer";

/**
 * Che telefono ha chi apre la pagina. Basta l'user agent più un dettaglio:
 * gli iPad recenti si presentano come un Mac, ma un Mac non ha lo schermo
 * tattile.
 */
export function dispositivoDa(userAgent: string, puntiTattili = 0): Dispositivo {
  if (/Android/i.test(userAgent)) return "android";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iphone";
  if (/Macintosh/i.test(userAgent) && puntiTattili > 1) return "iphone";
  return "computer";
}

export function dispositivoAttuale(): Dispositivo {
  if (typeof navigator === "undefined") return "computer";
  return dispositivoDa(navigator.userAgent, navigator.maxTouchPoints ?? 0);
}

/**
 * Il canale si scrive nell'indirizzo («?c=banco», «?c=firma»): così dai registri
 * del server si conta da dove arrivano le visite, senza cookie e senza
 * strumenti di tracciamento. Corto apposta: ogni carattere in più fa il QR più fitto.
 */
export function indirizzoDaCanale(canale: string): string {
  return `${INDIRIZZO_APP}?c=${encodeURIComponent(canale)}`;
}
